import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductOptions extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * Updates product options markup when the selected variant changes.
   * @param {CustomEvent} event
   */
  #handleVariantUpdate = (event) => {
    const currentProductId = String(this.dataset.productId || '');
    const eventProductId = String(event.detail?.data?.productId || '');
    const newProductId = String(event.detail?.data?.newProduct?.id || '');

    if (
      currentProductId
      && eventProductId !== currentProductId
      && newProductId !== currentProductId
    ) {
      return;
    }

    const renderId = this.dataset.renderId;
    if (!renderId) return;

    const allProductOptions = Array.from(event.detail?.data?.html?.querySelectorAll('product-options') || []);
    const newMarkup = allProductOptions.find((element) => element.dataset.renderId === renderId);
    if (!newMarkup) return;

    morph(this, newMarkup);
  };
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions);
}
